/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Context_Stop_Syncing_FolderInputs */



/**
* | output |
* | --- |
* | "Stop syncing this folder…" |
*
* @param {Spaces_Context_Stop_Syncing_FolderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_context_stop_syncing_folder = /** @type {((inputs?: Spaces_Context_Stop_Syncing_FolderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Context_Stop_Syncing_FolderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Ordner nicht mehr synchronisieren…")
	return /** @type {LocalizedString} */ ("Stop syncing this folder…")
});